export const entityView = (entity: string) => {
  const entityView = entity[0].toUpperCase() + entity.slice(1);
  return entityView;
};

export const getTagActionName = (entity: string): string => {
  return `Tagging of: ${entityView(entity)}`;
};
